import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { faqs } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="mx-auto px-4 md:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="FAQ"
              title="关于本站，你可能想问"
              desc="我们把读者问得最多的几个问题整理在这里，关于来源、隐私与更新节奏。"
            />
            <p className="mt-6 text-sm leading-7 text-foreground-600">
              还有别的疑问？欢迎通过底部的订阅与投稿表单告诉我们。
            </p>
          </div>

          <div className="lg:col-span-8">
            <ul className="divide-y divide-foreground-950/10 overflow-hidden rounded-lg border border-foreground-950/10 bg-background-50">
              {faqs.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <li key={item.q}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-7"
                      >
                        <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                          {item.q}
                        </span>
                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-lg transition-colors ${
                            isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                          }`}
                        >
                          <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <div className="px-5 pb-6 md:px-7">
                        <p className="max-w-3xl text-sm leading-8 text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}